import { Wifi, Battery, Smartphone, Signal } from "lucide-react";
import "./DeviceInfoCard.css";

export default function DeviceInfoCard({
  deviceId,
  deviceName,
  batteryLevel,
  isConnected,
  lastSync
}) {
  return (
    <div className="device-card-premium glass-card">
      <div className="device-header">
        <div className="device-title">
          <Smartphone size={18} />
          <span>Device Info</span>
        </div>
        <div className={`connection-badge ${isConnected ? "connected" : "disconnected"}`}>
          {isConnected ? "Connected" : "Disconnected"}
        </div>
      </div>

      <div className="device-info-grid">
        <div className="info-item">
          <span className="info-label">Device ID</span>
          <span className="info-value">{deviceId}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Device Name</span>
          <span className="info-value">{deviceName}</span>
        </div>
      </div>

      <div className="device-metrics-row">
        <div className="device-stat-item">
          <div className="stat-icon-box battery">
            <Battery size={16} />
          </div>
          <div className="stat-details">
            <span className="stat-label">Battery</span>
            <span className="stat-value">{batteryLevel}%</span>
          </div>
        </div>

        <div className="device-stat-item">
          <div className="stat-icon-box wifi">
            <Wifi size={16} />
          </div>
          <div className="stat-details">
            <span className="stat-label">Connection</span>
            <span className="stat-value">WiFi</span>
          </div>
        </div>

        <div className="device-stat-item">
          <div className="stat-icon-box signal">
            <Signal size={16} />
          </div>
          <div className="stat-details">
            <span className="stat-label">Signal</span>
            <span className="stat-value success">Excellent</span>
          </div>
        </div>
      </div>

      <div className="device-footer">
        <span>Last synced: {lastSync}</span>
      </div>
    </div>
  );
}
